/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateProposalPolicyPage = lazyLoad(
  () => import('./index'),
  module => module.CreateProposalPolicyPage
);
